(function () {

  const CART_WEBHOOK_URL = "https://script.google.com/macros/s/AKfycbxS8_ExgQrDvqF_AXoR1PxyYJrLDT2iNyYbgksLjyIMJK8nzBbNZlgY5sWMzWsj8oUN/exec";

  var email      = sessionStorage.getItem("pm_email");
  var product    = sessionStorage.getItem("pm_product")     || document.title.replace(" – PrintsMuse", "").trim();
  var productUrl = sessionStorage.getItem("pm_product_url") || window.location.href;
  var pages      = [];

  try { pages = JSON.parse(sessionStorage.getItem("pm_pages") || "[]"); } catch(e) {}

  function sendAction(action) {
    if (!email) return;
    fetch(CART_WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({
        action:        action,
        email:         email,
        product:       product,
        product_url:   productUrl,
        visited_pages: pages.join(" > ")
      }),
      mode: "no-cors"
    }).catch(function () {});
  }

  // ── On /cart page → schedule abandonment email ──
  if (window.location.pathname.includes("/cart")) {
    if (email && sessionStorage.getItem("pm_cart_scheduled") !== "1") {
      sessionStorage.setItem("pm_cart_scheduled", "1");
      sendAction("schedule");
    }
  }

  // ── If visitor goes back to a product page → reset schedule flag ──
  // so if they add a different product to cart it schedules again
  if (window.location.pathname.includes("/products/")) {
    sessionStorage.removeItem("pm_cart_scheduled");
  }

})();